import { selectUserRolePermissions } from '@socialive/common';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { selectAccountId, selectAccountRole, selectApiBaseUrl, selectUserId } from '~/store';
import '~/style/broadcastdetails.css';
import BroadcastStreams from '../../components/BroadcastStreams';
import Clips from '../../components/Clips';
import HeroStream from '../../components/HeroStream';
import decodeURIComponentSafe from '../../helpers/decodeURIComponentSafe';
import { routerHistoryShape, routerLocationShape, routerMatchShape } from '../../helpers/propTypeShapes';
import BroadcastDetailsNav from './BroadcastDetailsNav';

class BroadcastDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeComponent: this.props.match.params.deeplink,
      broadcast: null,
      latestStream: null,
      streams: null,
      streamCount: 0,
      newBroadcastTitle: '',
    };
    // this.state.activeComponent = this.props.match.params.deeplink;
    this.navigateLowerPanel = this.navigateLowerPanel.bind(this);
    this.getHeroStream = this.getHeroStream.bind(this);
    this.hydratePage = this.hydratePage.bind(this);
    this.reduceStreamCount = this.reduceStreamCount.bind(this);
    this.handleBroadcastTitleChange = this.handleBroadcastTitleChange.bind(this);
  }

  componentDidMount() {
    const { activeComponent } = this.state;
    const authorized = this.props.checkAuthorization(encodeURIComponent(this.props.location.pathname));
    if (!authorized) {
      return;
    }

    this.hydratePage();

    // render the recordings tabPanel in case the comments url is input directly.
    if (activeComponent === 'comments') {
      this.navigateLowerPanel('streams');
    }
  }

  handleBroadcastTitleChange(title) {
    this.setState({ newBroadcastTitle: title });
  }

  async getHeroStream(params) {
    const { apiBaseUrl, accountId, userId, canViewOwnRecordings, canViewAllRecordings } = this.props;
    const userQuery = canViewOwnRecordings && !canViewAllRecordings ? `user.id==${userId};` : '';

    try {
      const response = await fetch(
        `${apiBaseUrl}/search/streams?q=broadcast.hash==${this.props.match.params.hash};${userQuery}deletedAt=lt=1&accountId=${accountId}&sort=stoppedAt,desc&size=249`,
        params
      );
      if (response.status === 401) {
        // eslint-disable-next-line no-console
        console.error('Received 401 response from getHeroStream. Redirecting to login.');
        this.props.reAuth(this.props.location.pathname, encodeURIComponent(this.props.location.search));
        return;
      }
      if (response.status === 403) {
        // eslint-disable-next-line no-console
        console.error(
          'Received 403 response from hydratePage (broadcasts). User does not have privilege to access attempted broadcast.'
        );
        return;
      }

      const data = await response.json();
      let heroIndex;

      const broadcastUserId = this.state.broadcast.user.id;

      for (let index = 0; index <= data.content.length - 1; index += 1) {
        if (data.content[index].user.id === broadcastUserId) {
          heroIndex = index;
          break;
        } else if (index === data.content.length - 1) {
          heroIndex = 0;
        }
      }
      this.setState(
        {
          latestStream: data.content[heroIndex],
          streamCount: data.content.length,
          newBroadcastTitle: data.content[heroIndex].broadcast
            ? decodeURIComponentSafe(data.content[heroIndex].broadcast.name)
            : '',
        },
        () => {
          data.content.splice(heroIndex, 1);
          this.setState({
            streams: data.content,
          });
        }
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('get herostream API call failed. ', error);
    }
  }

  validateAccount(accountId) {
    const { accountId: currentAccountId } = this.props;
    const accounts = JSON.parse(sessionStorage.getItem('accounts'));
    const account = accounts.find(({ id }) => id === accountId);
    const {
      name: accountName,
      accountUsers: { role },
    } = account;

    if (accountId !== currentAccountId) {
      this.props.switchAccount({
        accountId,
        accountName,
        role,
        pathNames: [this.props.location.pathname],
      });
    }
  }

  async hydratePage() {
    const { apiBaseUrl } = this.props;
    const params = {
      headers: {
        authorization: sessionStorage.getItem('authToken'),
      },
    };

    if (this.props.match.params.streamOrBroadcast === 'broadcast') {
      const URL = `${apiBaseUrl}/broadcast/detail?hash=${this.props.match.params.hash}`;

      try {
        const accountResponse = await fetch(URL, params);
        if (accountResponse.status === 401) {
          // eslint-disable-next-line no-console
          console.error('Received 401 response from hydratePage (broadcasts). Redirecting to login.');
          this.props.reAuth(this.props.location.pathname, encodeURIComponent(this.props.location.search));
          return;
        }
        if (accountResponse.status === 403) {
          // eslint-disable-next-line no-console
          console.error(
            'Received 403 response from hydratePage. User does not have privilege to access attempted broadcast.'
          );
          return;
        }

        const { accountId } = await accountResponse.json();
        this.validateAccount(+accountId);

        try {
          const response = await fetch(
            `${apiBaseUrl}/search/broadcasts?accountId=${accountId}&q=hash==${this.props.match.params.hash}`,
            params
          );
          if (response.status === 401) {
            // eslint-disable-next-line no-console
            console.error('Received 401 response from hydratePage (broadcasts). Redirecting to login.');
            this.props.reAuth(this.props.location.pathname, encodeURIComponent(this.props.location.search));
            return;
          }
          if (response.status === 403) {
            // eslint-disable-next-line no-console
            console.error(
              'Received 403 response from hydratePage (broadcasts). User does not have privilege to access attempted broadcast.'
            );
            return;
          }

          const data = await response.json();
          this.setState({ broadcast: { ...data.content[0], isStream: false } }, () => {
            this.getHeroStream(params);
          });
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('broadcastdetails broadcasts API call failed. ', error);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`hydratePage initial call failed: ${URL} : `, error);
      }
    } else {
      try {
        const response = await fetch(
          `${apiBaseUrl}/stream/detail?id=${this.props.match.params.id}&projection=detail`,
          params
        );
        if (response.status === 401) {
          // eslint-disable-next-line no-console
          console.error('Received 401 response from hydratePage (broadcasts). Redirecting to login.');
          this.props.reAuth(this.props.location.pathname, encodeURIComponent(this.props.location.search));
          return;
        }
        if (response.status === 403) {
          // eslint-disable-next-line no-console
          console.error(
            'Received 403 response from hydratePage (streams). User does not have privilege to access attempted broadcast.'
          );
          return;
        }

        const { accountId, title } = await response.json();
        this.validateAccount(+accountId);

        try {
          const resp = await fetch(
            `${apiBaseUrl}/search/streams?accountId=${accountId}&q=id==${this.props.match.params.id};deletedAt=lt=1`,
            params
          );
          if (resp.status === 401) {
            // eslint-disable-next-line no-console
            console.error('Received 401 response from hydratePage (streams). Redirecting to login.');
            this.props.reAuth(this.props.location.pathname, encodeURIComponent(this.props.location.search));
            return;
          }
          if (resp.status === 403) {
            // eslint-disable-next-line no-console
            console.error(
              'Received 403 response from hydratePage (streamData). User does not have privilege to access attempted broadcast.'
            );
            return;
          }

          const data = await resp.json();
          const latestStream = data.content[0];
          const name = title || `${latestStream.user.name}, ${latestStream.user.location}`;
          this.setState({
            broadcast: {
              id: +this.props.match.params.id,
              isStream: true,
              name,
              description: latestStream.description,
              remoteStream: {
                token: latestStream.remoteStream.token,
                name: latestStream.remoteStream.name,
              },
              user: {
                id: latestStream.user.id,
              },
            },
            latestStream,
            newBroadcastTitle: latestStream.broadcast ? decodeURIComponentSafe(latestStream.broadcast.name) : '',
            streams: [],
          });
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('broadcastdetails streams API call failed. ', error);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Stream/detail API call failed. ', error);
      }
    }
  }

  navigateLowerPanel(tab) {
    let { pathname } = document.location;
    const path = `/${tab}`;

    if (pathname.includes('/streams')) {
      pathname = pathname.replace('/streams', path);
    } else if (pathname.includes('/comments')) {
      pathname = pathname.replace('/comments', path);
    } else if (pathname.includes('/clips')) {
      pathname = pathname.replace('/clips', path);
    }
    this.setState({ activeComponent: tab });
    this.props.history.push(pathname);
  }

  reduceStreamCount() {
    this.setState((prevState) => ({ streamCount: prevState.streamCount - 1 }));
  }

  render() {
    const { accountId, apiBaseUrl, accountRole, componentReady, history, location, match, reAuth, trackEvent } =
      this.props;
    const { activeComponent, broadcast, latestStream, streams } = this.state;

    if (!componentReady || !(broadcast && latestStream)) {
      return <div />;
    }

    if (activeComponent === 'comments') {
      sessionStorage.setItem('currentChannelToken', broadcast.remoteStream.token);
      sessionStorage.setItem('currentBroadcastId', match.params.id);
      sessionStorage.setItem('currentBroadcastHash', match.params.hash);
      localStorage.setItem('currentBroadcastId', match.params.id);
      localStorage.setItem('currentBroadcastHash', match.params.hash);
    }

    return (
      <div className="broadcast-details-content content-container">
        <HeroStream
          APIBaseURL={apiBaseUrl}
          broadcast={broadcast}
          handleBroadcastTitleChange={this.handleBroadcastTitleChange}
          heroStream={latestStream}
          history={history}
          location={location}
          match={match}
          newBroadcastTitle={this.state.newBroadcastTitle}
          reAuth={reAuth}
          reduceStreamCount={this.reduceStreamCount}
          streamCount={this.state.streamCount}
          trackEvent={trackEvent}
          type={match.params.streamOrBroadcast}
        />
        <BroadcastDetailsNav activeTabId={activeComponent} handleOnclick={this.navigateLowerPanel} />

        {activeComponent === 'streams' && streams && (
          <BroadcastStreams
            accountId={accountId}
            accountRole={accountRole}
            APIBaseURL={apiBaseUrl}
            broadcast={broadcast}
            location={location}
            newBroadcastTitle={this.state.newBroadcastTitle}
            updateStreams={(newStreams) => this.setState({ streams: newStreams })}
            reAuth={reAuth}
            reduceStreamCount={this.reduceStreamCount}
            streams={streams}
            trackEvent={trackEvent}
          />
        )}

        {activeComponent === 'clips' && (
          <Clips
            APIBaseURL={apiBaseUrl}
            broadcastHash={broadcast.hash}
            broadcastId={broadcast.id}
            broadcastTitle={this.state.newBroadcastTitle}
            getPrimaryKey={this.props.getPrimaryKey}
            location={location}
            streamOrBroadcast={match.params.streamOrBroadcast}
            reAuth={reAuth}
            subjectId={match.params.id}
            trackEvent={trackEvent}
          />
        )}
      </div>
    );
  }
}

BroadcastDetails.propTypes = {
  accountId: PropTypes.number.isRequired,
  accountRole: PropTypes.string.isRequired,
  apiBaseUrl: PropTypes.string.isRequired,
  canViewOwnRecordings: PropTypes.bool.isRequired,
  canViewAllRecordings: PropTypes.bool.isRequired,
  checkAuthorization: PropTypes.func.isRequired,
  componentReady: PropTypes.bool.isRequired,
  getPrimaryKey: PropTypes.func.isRequired,
  history: routerHistoryShape.isRequired,
  location: routerLocationShape.isRequired,
  match: routerMatchShape.isRequired,
  reAuth: PropTypes.func.isRequired,
  switchAccount: PropTypes.func.isRequired,
  trackEvent: PropTypes.func.isRequired,
  userId: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => {
  const { canViewOwnRecordings, canViewAllRecordings } = selectUserRolePermissions(state);
  return {
    canViewOwnRecordings,
    canViewAllRecordings,
    accountId: selectAccountId(state),
    accountRole: selectAccountRole(state),
    apiBaseUrl: selectApiBaseUrl(state),
    userId: selectUserId(state),
  };
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(BroadcastDetails);
